import OrdersPageView from "./OrdersPageView";

function OrdersPage() {
  return <OrdersPageView />;
}

export default OrdersPage;
